
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        categoriesList: [ ],
        tableColumns: ['name', 'default_points','for_lead', 'for_employee', 'action'],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
